

















exports.default =
  components:
    list: require('./list')

  data: ->
    list_item_options:
      show_user: true
      row_click_action: 'select'
      action: 'select'
      show_contacts_count: false
      show_reply_statistic: false

    filter_options:
      show_user_filter: true

    options:
      show_everybodys_flows: true




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/library.vue